import { Customer, ILeadActivity, MediaFile, OwnerUser, Lead, IOfficeLocation } from "..";

import { LeadRequirement } from "./requirement";

export interface ProposalReason {
  _id?: string;
  code: string;
  reason: string;
  visibility?: boolean;
}

export interface Proposal {
  projectImages: any[];
  capturedLocationImage: MediaFile;
  innerImagesMedia: any[];
  coverImagesMedia: any[];
  liftDetails: { noOfLiftPassenger : string; noOfLiftService: string };
  companyName: string;
  organizationLogo: string | undefined;
  furnishingDetailsViewOption: string;
  excludeFloorPlan: boolean;
  _id: string;
  title: string;
  masterRequirementId: string;
  requirementDetails: LeadRequirement;
  versionNumber: number;
  createdBy?: OwnerUser;
  approvedBy?: OwnerUser;
  createdAt?: Date;
  updatedAt?: Date;
  status?: string;
  createProposalReason?: string;
  sendProposalReason?: string;
  stage?: string;
  capturedLocationsImage?: MediaFile;
  proposalFormatType: ProposalFormatType;
  proposalContentType: ProposalContentType;
  proposalType: ProposalType;
  proposalStage: ProposalStage;
  customerDetails?: Customer;
  activityDetails?: ILeadActivity;
  createProposalComment?: string;
  sendProposalStatus?: SendProposalStatus;
  latestSentDate?: Date;
  latestDownloadDate?: Date;
  companyDetails?: {
    name?: string;
    _id?: string;
    primaryPhone?: string;
    primaryEmail?: string;
  };
  sendProposalComment?: string;
  tagFrom?: string;
  properties?: any[];
  currentOffice?: IOfficeLocation;
}

export interface ProposedPropertyDetails {
  proposedProperties: ProposedProperty[];
  proposals: Proposal[];
}

export interface CSLInitial {
  _id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  movedBy: OwnerUser;
  status?: CSLStatus;
}

export enum CSLStatus {
  Added = "Added",
  Removed = "Removed",
}

export interface CSLFinal {
  _id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  movedBy: OwnerUser;
}

export interface PropertyDetailsFromProject {
  projectId: string;
  propertyId: string;
  propertyName: string;
  projectName: string;
  propertyAddress: string;
  floor: number;
  unitId: number;
  unitName: string;
  area: number;
  interiorType: string;
  quotedRent: string;
  currentStatus: string;
  propertyCoverImage: string;
  propertySqrFeet: null;
  developer: string;
  pricePerSqft: number;
  availableUnits: number;
  requirementVersion: number;
  availableFrom?: Date;
  _id: string;
}

export interface ProposedPropertyDetails {
  propertyId: string;
  propertyName: string;
  propertyCoverImage: string;
  propertySqrFeet: string;
  pricePerSqft: string;
  availableUnits: string;
  propertyDetailsFromProject: PropertyDetailsFromProject;
  city: {
    cityName: string;
    cityID: number;
    _id: string;
  };
  cityLocation: {
    cityName: string;
    cityLocName: string;
    _id: string;
  };
  cityZone: {
    cityId: string;
    cityName: string;
    cityZoneName: string;
    _id: string;
  };
  propertyLatitude: string;
  propertyLongitude: string;
  _id: string;
}

export interface ProjectDetails {
  projectName: string;
  projectID: number;
  projectKey: string;
  projectCurrentStatus: string;
  projectAddedDate: Date;
  projectDescription: string;
  projectPossessionDate: Date;
  projectUserCompanyName: string;
  projectUserCompanyLogo: string;
  projectBuilderName: {
    developer: string;
    _id: string;
    createdAt: Date;
    updatedAt: Date;
  };
  projectFavourite: string;
  projectCoverImage: string;
  projectTypeID: number;
  projectTypeName: string;
  projectTypeKey: string;
  grade: string;
  _id: string;
}

export interface ProposedProperty {
  _id?: string;
  proposalId?: string;
  masterRequirementId: string;
  proposalVersion: number;
  propertyDetails: any;
  proposalType: ProposalType;
  proposalStage: ProposalStage;
  draftProposalStatus?: DraftProposalStatus;
  cslInitial?: CSLInitial;
  cslFinal?: CSLFinal;
  rejectReason?: string;
  propertyLatitude?: number;
  propertyLongitude?: number;
  projectDetails: ProjectDetails;
  comment?: string;
}

export enum ProposalType {
  Draft = "Draft",
  Sent = "Sent",
  Rejected = "Rejected",
  Approved = "Approved",
}

export enum ProposalStage {
  Proposed = "Proposed",
  CustomerShortListInitial = "CustomerShortListInitial",
  CustomerShortListFinal = "CustomerShortListFinal",
  TermSheetSubmission = "TermSheetSubmission",
  FeeConfirmation = "FeeConfirmation",
  LetterForIntent = "LetterForIntent",
  LegalDueDiligence = "LegalDueDiligence",
  Agreement = "Agreement",
  Invoice = "Invoice",
}

export enum DraftProposalStatus {
  Deleted = "Deleted",
  Rejected = "Rejected",
  Approved = "Approved",
  Edited = "Edited",
  Requested = "Requested",
}

export enum ProposalFormatType {
  PDF = "PDF",
  EXCEL = "EXCEL",
}

export enum ProposalContentType {
  Long = "Long",
  Medium = "Medium",
  Small = "Small",
}

export enum SendProposalStatus {
  Rejected = "Rejected",
  Approved = "Approved",
  Requested = "Requested",
}

export interface UpdateSendProposalStatusDto {
  proposalId: string;
  status?: SendProposalStatus;
  rejectReason?: string;
  comment?: string;
}

export interface CommissionObject {
  commissionType?: string;
  numberOfMonths?: number;
  amount?: number;
  acceptanceAndAgreedBy?: OwnerUser;
  feeLetterId?: string;
}

export enum PaidBy {
  Client = "Client",
  LandLord = "LandLord",
}


export enum DocumentCopyType {
  ClientCopy = 'Client Copy',
  LandlordCopy = 'Landlord Copy',
}


export enum MainTabLabels {
  Client = "Client",
  LandLord = "LandLord",
}